const { langs } = require('src/constants/language');

export const usePreventTranslate = (children) => {
  if (typeof children === 'string') {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const l = params.get('l') ?? '';
    const replaced = langs[l]?.[children] ?? children;

    return {
      replaced: Boolean(children !== replaced),
      content: replaced,
    };
  }

  return {
    replaced: false,
    content: children,
  };
};
